import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TableFooter from "@/components/TableFooter.vue";
import { onMounted, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import TimeShow from "@/components/TimeShow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerServices',
  setup(__props) {

const detailVisible = ref(false);

const isLoading = ref(true);
const dialogItem = ref({});
const items = ref(Array<any>());
const criteria = ref({
  page: 1,
  size: 20,
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;

  //   try {
  //     const res = await TenantGlobalService.queryApiLogs(criteria.value);
  //     items.value = res.data;
  //     criteria.value = res.criteria;
  //     isLoading.value = false;
  //   } catch (error) {
  //     console.log(error);
  //   }
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Services"))
}
}

})